import React from 'react';
import clsx from 'clsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import { WhisperComponent } from '../developers/page-components/WhisperComponent';
import { TypeAttributes } from 'rsuite/cjs/internals/types';

interface GetTitleProps {
        className?: string;
        label?: string;
        fieldLabel?: React.ReactNode;
        isLabelIcon?: boolean;
        tooltipText?: string;
        tooltipPlacement?: TypeAttributes.Placement;
        t: (key: string) => string;
}

export const getTitle = ({
                                 className,
                                 label,
                                 fieldLabel,
                                 isLabelIcon,
                                 tooltipText,
                                 tooltipPlacement,
                                 t,
                         }: GetTitleProps): JSX.Element => (
    <>
            <div className={clsx('d-flex align-items-center mb-1', className)}>
                    {Boolean(label) && <label className="fs-6 text-black">{fieldLabel}</label>}
                    {isLabelIcon && (
                        <div className="cursor-pointer ms-1">
                                <WhisperComponent
                                    isTooltip
                                    whisperText={t(tooltipText || '')}
                                    placement={tooltipPlacement}
                                    mainText={<FontAwesomeIcon icon={faQuestionCircle} width={12} />}
                                />
                        </div>
                    )}
            </div>
    </>
);
